import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? match[1] : null;
    if (!session_id) {
      navigate("/admin/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id },
          { withCredentials: true }
        );
        navigate("/admin/triagem", { replace: true, state: { user: data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Falha ao autenticar.";
        setError(msg);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="auth-callback">
      {error ? (
        <div className="max-w-md text-center">
          <div className="text-red-700 font-display font-bold text-lg mb-2">Não foi possível entrar</div>
          <p className="text-sm text-ga-ink/70 mb-4">{error}</p>
          <button onClick={() => navigate("/admin/login")} className="btn-outline" data-testid="auth-callback-retry">
            Voltar ao login
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-3 text-ga-ink/70">
          <Loader2 className="w-5 h-5 animate-spin" />
          Autenticando…
        </div>
      )}
    </div>
  );
}
